// extracted by mini-css-extract-plugin
module.exports = {"modal":"TweetModal_modal__3zNe6","close":"TweetModal_close__3_HZX","tweet":"TweetModal_tweet__15uqs"};